module.exports = __webpack_public_path__ + "img/support-1.1b9b2d17.png";